import { BLOCKS } from '@contentful/rich-text-types';
import { anchorColor, textMd } from '@insify/design-system/typography';
import clsx from 'clsx';

import { RichContent } from '../../../../components/RichContent';

import styles from './SectionHeader.module.css';

import type { RichContentProps, RichContentType } from '../../../../components/RichContent';

const HeaderContent = (props: RichContentProps) => (
  <RichContent
    renderNode={{
      [BLOCKS.HEADING_2]: (_, children) => <RichContent.H2 className={styles.heading}>{children}</RichContent.H2>,
      [BLOCKS.PARAGRAPH]: (_, children) => <RichContent.P className={styles.paragraph}>{children}</RichContent.P>,
    }}
    {...props}
  />
);

type Props = {
  className?: string;
  children?: React.ReactNode;
};

const SectionHeader = ({ className, children }: Props) => (
  <div className={clsx(styles.header, className)}>{children}</div>
);

SectionHeader.Content = ({ className, content }: { className?: string; content?: RichContentType }) => (
  <HeaderContent className={className} content={content} />
);

SectionHeader.Heading = ({ className, children }: Props) => (
  <RichContent.H2 className={clsx(styles.heading, className)}>{children}</RichContent.H2>
);

SectionHeader.Paragraph = ({ className, children }: Props) => (
  <RichContent.P className={clsx(styles.heading, className)}>{children}</RichContent.P>
);

SectionHeader.ModalButton = ({ className, onClick, children }: Props & { onClick: React.MouseEventHandler }) => (
  <button type='button' className={clsx(anchorColor, textMd, styles.modalButton, className)} onClick={onClick}>
    {children}
  </button>
);

export { SectionHeader };
